module.exports = __webpack_public_path__ + "img/p8.a6aa5ea9.png";